/* eslint-disable prefer-const */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { IconContext } from 'react-icons';
import { BsArrowLeftShort } from 'react-icons/bs';
import { FaCheckCircle } from 'react-icons/fa';
import { Modal } from 'reactstrap';
import classNames from 'classnames';

import InputRadio from '../Forms/Input/RadioV3';
import SwitchToggle from '../Forms/SwitchToggle';

import {
  BANKTRANSFER,
  CREDITCARD,
  FULLWALLET,
  AKULAKU,
  MANDIRI_VA,
  BCA_VA,
  DEFAULT_CREDIT_CARD,
  DEFAULT_PAYMENT_METHOD,
  BCA_CREDIT_CARD,
} from '../../constants/paymentMethods';
import { convertToRupiah, formatRupiah, getCloudImageUrl } from '../../utils';
import { RESOURCE_URL as ASSET_IMAGE } from '../../config';

import AuthInterface from '../../interface/reducers/auth';
import DataOfferInterface, {
  OfferDetailsInterface,
} from '../../interface/reducers/offer';
import { GrClose } from 'react-icons/gr';

interface stateToProps {
  dataCart: any;
  dataAuth: AuthInterface;
  dataProduct: any;
  dataOffer: DataOfferInterface;
}

interface ModalUpdatePaymentOfferInterface {
  dataCart: any;
  dataAuth: AuthInterface;
  dataOffer: OfferDetailsInterface;
  isModalOpen: boolean;
  currency: string;
  onToggle: any;
  handleCurrentPaymentType: any;
  isSelectPaymentFlagging: any;
  currentShippingPrice: number | string;
  currentShippingCountry: string;
  currentOfferData: number | string;
  currentPayment: typeof DEFAULT_PAYMENT_METHOD[0];
}

interface ModalUserCreditInterface {
  balance: any;
  sellerCredit: any;
  kickPoints: any;
  useKickPoints: any;
  setUseKickPoints: any;
  paymentType: any;
  temporaryPaymentMethod: any;
  newTotalAmount: any;
}

const ModalUserCredit = ({
  balance,
  sellerCredit,
  kickPoints,
  useKickPoints,
  setUseKickPoints,
  paymentType,
  temporaryPaymentMethod,
  newTotalAmount,
}: ModalUserCreditInterface) => {
  const totalCreditBalance = Number(balance) + Number(sellerCredit);

  return (
    <div className="payment-method-wrapper update-payment-method-wrapper">
      <div
        className={classNames(
          'update-payment-method-outer-wrapper user-credit',
          {
            'is-selected':
              paymentType === FULLWALLET ||
              (temporaryPaymentMethod &&
                temporaryPaymentMethod.payment_method === FULLWALLET),
          },
        )}
      >
        <KickImage
          className="payment-methods-logo-update-payment"
          src={getCloudImageUrl(`${ASSET_IMAGE}email/kick_check.png`, 200)}
          alt="payments-logo"
        />
        <div className="all-credit-wrapper">
          <p className="title">Credit</p>
          <p>Balance: {convertToRupiah(totalCreditBalance)}</p>
          <div className="user-credit-wrapper">
            <p>Kick Credit {convertToRupiah(Number(balance))}</p>
            <p>Seller Credit {convertToRupiah(Number(sellerCredit))}</p>
          </div>
        </div>
      </div>
      <div className="update-payment-method-outer-wrapper user-credit">
        <div className="all-credit-wrapper">
          <p className="title">Use Kick Points</p>
          <p>Balance: {convertToRupiah(Number(kickPoints))}</p>
        </div>
        <SwitchToggle
          active={useKickPoints}
          onClick={() => setUseKickPoints(!useKickPoints)}
          disabled={
            Number(kickPoints) === 0 ||
            totalCreditBalance < Number(newTotalAmount)
          }
        />
      </div>
    </div>
  );
};

/**
 * Modal to Update used Payment Method on offer for  Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {ModalUpdatePaymentOfferInterface} props for this component.
 * @return {JSX.Element}
 */
function ModalUpdatePaymentOffer({
  isModalOpen,
  dataCart,
  currency,
  dataOffer,
  dataAuth,
  onToggle,
  handleCurrentPaymentType,
  isSelectPaymentFlagging,
  currentShippingPrice,
  currentShippingCountry,
  currentOfferData,
  currentPayment,
}: ModalUpdatePaymentOfferInterface) {
  const [isIndonesian, setIsIndonesia] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState(DEFAULT_PAYMENT_METHOD);
  const [paymentType, setPaymentType] = useState(
    currency === 'IDR' ? MANDIRI_VA : CREDITCARD,
  );
  const [temporaryPaymentMethod, setTemporaryPaymentMethod] =
    useState<any>(null);
  const [paymentLabel, setPaymentLabel] = useState<any>(null);
  const [openUserCredit, setOpenUserCredit] = useState(false);
  const [useKickPoints, setUseKickPoints] = useState(false);
  const [isBcaCard, setIsBcaCard] = useState(false);

  useEffect(() => {
    const setPayment: string | string[] = [];
    const variant_payment_methods =
      dataOffer.data && dataOffer.data.product_variant.variant_payment_methods;

    if (variant_payment_methods && variant_payment_methods.length > 0) {
      (async () => {
        const dataPayments = paymentMethods.map((payments) => {
          let variantPaymentMethod = Object.assign({}, payments);
          variant_payment_methods.find((item) => {
            if (!setPayment.includes(payments.payment_method)) {
              setPayment.includes(item.payment_method)
                ? null
                : setPayment.push(item.payment_method);
              variantPaymentMethod.active = false;
            } else {
              variantPaymentMethod.active = true;
            }
          });
          return variantPaymentMethod;
        });

        let isBankTransfer: Array<any> = [];
        let newDataPayment: any[] = [];

        dataPayments.forEach((payments) => {
          if (payments.payment_method === 'bank_transfer') {
            isBankTransfer.push(payments);
          } else {
            newDataPayment.push(payments);
          }
        });

        if (setPayment.length) {
          newDataPayment = newDataPayment.filter((item) => {
            return setPayment.includes(item.payment_method);
          });
        }

        await setPaymentMethods(newDataPayment.concat(isBankTransfer));
      })();
    }

    if (dataOffer.data) {
      const { payment_type, lbalance_amount, payment_via } = dataOffer.data;
      setPaymentType(payment_type);
      setIsBcaCard(payment_via === 'spa' && payment_type === 'credit_card');
      if (payment_via === 'spa' && payment_type === 'credit_card')
        setPaymentLabel('BCA Card');
      else setPaymentLabel(null);
      if (Number(lbalance_amount) > 0) setUseKickPoints(true);
    }

    if (
      dataAuth &&
      dataAuth.userdata &&
      dataAuth.userdata.country_code === 'IDN'
    ) {
      setIsIndonesia(true);
    }
  }, [dataOffer.data]);

  useEffect(() => {
    paymentMethods &&
      paymentMethods.forEach((item) => {
        if (
          item.payment_group === 1 ||
          (item.payment_group === 3 && item.payment_method !== AKULAKU)
        ) {
          if (
            paymentType === item.payment_method &&
            isBcaCard &&
            item.label === 'BCA Card'
          ) {
            setTemporaryPaymentMethod(item);
          }
        }
      });
  }, [paymentType]);

  useEffect(() => {
    if (isModalOpen) {
      setPaymentType(currentPayment.payment_method);
      setOpenUserCredit(false);
      setIsBcaCard(currentPayment.label === 'BCA Card');
    }

    if (currentShippingCountry !== 'IDN') {
      let newDataPayment = paymentMethods.filter(
        (item) =>
          item.payment_method === DEFAULT_CREDIT_CARD &&
          item.label !== 'BCA Card',
      );
      setPaymentMethods(newDataPayment);
    } else {
      setPaymentMethods(DEFAULT_PAYMENT_METHOD);
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (currentShippingCountry !== 'IDN') {
      let defaultCc = paymentMethods.filter(
        (item) =>
          item.payment_method === DEFAULT_CREDIT_CARD &&
          item.label !== 'BCA Card',
      );
      defaultCc.length
        ? handleCurrentPaymentType(defaultCc[0], useKickPoints)
        : null;
    }
  }, [currentShippingCountry]);

  const renderPaymentTitle = (item: any) => {
    const shouldRender =
      paymentMethods.filter((p) => p.type === item.type).length === 1;

    if (item.type === 'credit_card') {
      return (
        <>
          {(item.payment_method == BCA_CREDIT_CARD || shouldRender) && (
            <div className={'payment-methods-section-title'}>
              <p>Credit Card</p>
              <p>
                Your payment will be verified automatically by the payment
                gateway.
              </p>
            </div>
          )}
        </>
      );
    } else if (item.type === 'virtual_account') {
      return (
        <>
          {(item.payment_method == BCA_VA || shouldRender) && (
            <div className={'payment-methods-section-title'}>
              <p>Virtual Account</p>
              <p>
                Your payment will be verified automatically by the payment
                gateway.
              </p>
            </div>
          )}
        </>
      );
    }

    return null;
  };

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={onToggle}
      className="payment-method-container-v3"
    >
      <div className="update-payment-method-header-wrapper">
        {/* {openUserCredit && (
          <KickImage
            className="back-img"
            src={Back}
            alt="..."
            onClick={() => {
              setOpenUserCredit(false);
              setTemporaryPaymentMethod(null);
            }}
          />
        )} */}
        <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
          <div
            style={{
              cursor: 'pointer',
              padding: '2.5px',
              backgroundColor: '#ebebeb',
              borderRadius: '50px',
            }}
            onClick={() => {
              if (openUserCredit) {
                setOpenUserCredit(false);
                return;
              }
              onToggle();
              setTemporaryPaymentMethod(null);
            }}
          >
            <BsArrowLeftShort />
          </div>
        </IconContext.Provider>
        <p>Change Payment</p>
      </div>
      <div className="update-payment-list-wrapper">
        {openUserCredit ? (
          <ModalUserCredit
            balance={dataAuth.userdata.balance}
            sellerCredit={dataAuth.userdata.balance_with_fee}
            kickPoints={dataAuth.userdata.locked_balance}
            setUseKickPoints={setUseKickPoints}
            useKickPoints={useKickPoints}
            paymentType={paymentType}
            temporaryPaymentMethod={temporaryPaymentMethod}
            newTotalAmount={Number(
              dataOffer.data && currentOfferData + currentShippingPrice,
            )}
          />
        ) : (
          <div className="payment-method-wrapper update-payment-method-wrapper">
            {paymentMethods &&
              paymentMethods.map((item, index) => {
                const isActive =
                  item.active &&
                  isIndonesian &&
                  Number(
                    dataOffer.data && currentOfferData + currentShippingPrice,
                  ) <
                    Number(dataAuth.userdata.balance) +
                      Number(dataAuth.userdata.balance_with_fee) +
                      Number(dataAuth.userdata.locked_balance);
                if (item.payment_group === 3) {
                  const isChecked =
                    paymentType !== 'credit_card'
                      ? paymentType === item.payment_method
                      : !paymentLabel
                      ? paymentType === item.payment_method
                      : paymentLabel === item.label;
                  const totalUserCredit =
                    Number(dataAuth.userdata.balance) +
                    Number(dataAuth.userdata.balance_with_fee);
                  const totalKickPoints = Number(
                    dataAuth.userdata.locked_balance,
                  );
                  return (
                    <>
                      {item.payment_method == FULLWALLET && (
                        <div className={'payment-methods-section-title'}>
                          <p>Credit</p>
                          <p>
                            Your payment will be verified automatically by the
                            payment gateway.
                          </p>
                        </div>
                      )}
                      <div
                        key={item.id}
                        className="update-payment-method-outer-wrapper"
                        onClick={() => {
                          if (isActive) {
                            setOpenUserCredit(true);
                            setPaymentType(item.payment_method);
                            setTemporaryPaymentMethod(item);
                          }
                        }}
                      >
                        <div className={'image-container'}>
                          <KickImage src={getCloudImageUrl(item.logo, 200)} />
                        </div>
                        <div className={'text-container'}>
                          <p className={'credit-title'}>{item.label}</p>
                          <p className={'credit-information'}>
                            Balance: {formatRupiah(totalUserCredit)}
                          </p>
                          <p className={'credit-information no-mb'}>
                            Kick Points: {formatRupiah(totalKickPoints)}
                          </p>
                        </div>
                        <div className={'input-container'}>
                          {isChecked ? (
                            <IconContext.Provider
                              value={{ color: '#159953', size: '20px' }}
                            >
                              <div
                                onClick={() => {
                                  if (isActive) {
                                    setPaymentType(item.payment_method);
                                    setTemporaryPaymentMethod(item);
                                  }
                                }}
                              >
                                <FaCheckCircle />
                              </div>
                            </IconContext.Provider>
                          ) : (
                            <input
                              style={{ cursor: 'pointer' }}
                              checked={isChecked}
                              type="radio"
                              onClick={() => {
                                if (isActive) {
                                  setPaymentType(item.payment_method);
                                  setTemporaryPaymentMethod(item);
                                }
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </>
                  );
                }
                return null;
              })}

            {/* INI UNTUK RENDER VIRTUAL ACCOUNT */}
            {paymentMethods &&
              paymentMethods.map((item, index) => {
                const isActive =
                  (item.active && isIndonesian) ||
                  (isIndonesian &&
                    item.payment_method === DEFAULT_CREDIT_CARD) ||
                  (!isIndonesian &&
                    item.payment_method === DEFAULT_CREDIT_CARD);

                let isChecked = false;
                if (
                  item.label === 'BCA Card' &&
                  isBcaCard &&
                  paymentType === 'credit_card'
                ) {
                  isChecked = true;
                } else {
                  isChecked =
                    item.label !== 'BCA Card' &&
                    !isBcaCard &&
                    paymentType === item.payment_method;
                }

                // HIDE BANK TRANSFER
                if (item.payment_method == BANKTRANSFER) return null;
                if (item.payment_group === 1) {
                  return (
                    <>
                      {renderPaymentTitle(item)}
                      {/* {item.payment_method == BANKTRANSFER && (
                        <div className={'payment-methods-section-title'}>
                          <p>Bank Transfer</p>
                          <p>
                            Please allow 1 working day for us to verify your
                            payment.
                          </p>
                        </div>
                      )} */}

                      <div
                        className="update-payment-method-outer-wrapper"
                        onClick={() => {
                          if (isActive) {
                            if (item.label === 'BCA Card') {
                              setPaymentLabel('BCA Card');
                              setIsBcaCard(true);
                            } else {
                              setPaymentLabel(null);
                              setIsBcaCard(false);
                            }
                            setPaymentType(item.payment_method);
                            setTemporaryPaymentMethod(item);
                          }
                        }}
                      >
                        <div className={'image-container'}>
                          {item.logo && (
                            <KickImage src={getCloudImageUrl(item.logo, 200)} />
                          )}
                        </div>
                        <div className={'text-container'}>
                          <p className={'credit-title no-mb'}>{item.label}</p>
                        </div>
                        <div className={'input-container'}>
                          {isChecked ? (
                            <IconContext.Provider
                              value={{ color: '#159953', size: '20px' }}
                            >
                              <div
                                onClick={() => {
                                  if (isActive) {
                                    setPaymentType(item.payment_method);
                                    setTemporaryPaymentMethod(item);
                                  }
                                }}
                              >
                                <FaCheckCircle />
                              </div>
                            </IconContext.Provider>
                          ) : (
                            <input
                              style={{ cursor: 'pointer' }}
                              checked={isChecked}
                              type="radio"
                              onClick={() => {
                                if (isActive) {
                                  if (item.label === 'BCA Card') {
                                    setPaymentLabel('BCA Card');
                                    setIsBcaCard(true);
                                  } else {
                                    setPaymentLabel(null);
                                    setIsBcaCard(false);
                                  }
                                  setPaymentType(item.payment_method);
                                  setTemporaryPaymentMethod(item);
                                }
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </>
                  );
                }
                return null;
              })}
          </div>
        )}
      </div>
      <div className="update-payment-methods-save-button-wrapper">
        {temporaryPaymentMethod || paymentLabel ? (
          <div
            className="update-payment-methods-save-button"
            onClick={() => {
              handleCurrentPaymentType(temporaryPaymentMethod, useKickPoints);
              setTemporaryPaymentMethod(null);
              setPaymentLabel(null);
              isSelectPaymentFlagging(true);
              onToggle();
            }}
          >
            <p>Save Payment</p>
          </div>
        ) : (
          <div className="update-payment-methods-save-button update-payment-method-disable-button">
            <p>Save Payment</p>
          </div>
        )}
      </div>
      <div className={'close-button'} onClick={onToggle}>
        <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
          <div>
            <GrClose />
          </div>
        </IconContext.Provider>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state: stateToProps) => ({
  dataCart: state.dataProduct.cart,
  currency: state.dataAuth.userCurrency.currency,
  dataOffer: state.dataOffer.offerDetails,
  dataAuth: state.dataAuth,
});

export default connect(mapStateToProps)(ModalUpdatePaymentOffer);
